<template>
  <v-app>
    <the-navigation-drawer />

    <the-app-bar :page-title="pageTitle" />

    <v-main>
      <component
        v-bind="$page.props"
        :is="$root.modalComponent"
        v-if="$root.modalComponent"
      />
      <notifications-dialog
        :show="$root.notificationsDialog.show"
        :notifications="$page.props.user.notifications"
        @hide="handleHideNotificationsDialog"
      />
      <confirm-dialog ref="confirm" />
      <flash-messages ref="flash" />

      <v-container
        v-if="! noWrappingContainer"
        fluid
      >
        <portal-target name="flash" />
        <slot />
      </v-container>

      <slot v-else />
    </v-main>
  </v-app>
</template>

<script>

export default {
  props: {
    pageTitle: {
      type: String,
      required: false,
      default: 'webcomet'
    },

    noWrappingContainer: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$snack = this.$refs.flash.snack;
    this.$root.$reset = this.$refs.flash.reset;
  },

  methods: {
    url() {
      return location.pathname.substr(1);
    },

    handleHideNotificationsDialog() {
      this.$root.hideNotificationsDialog();
    }
  }
}
</script>